import { type AppId } from '@post-office/rovo-expansion-common';

import { matchProviderKey } from '../providerPatterns.ts';

import { resolveProviderKeyToAppId } from './resolveProviderKeyToAppId.ts';

export type PageProductsResult = {
	appIds: Set<AppId>;
	/** Addresses matching no pattern, mostly self-hosted hosts. Counted to keep the gap visible. */
	unmatchedAddressCount: number;
};

/**
 * The products a page links to. One provider key maps to two products and only the preferred one is
 * taken, so a SharePoint-only page does not prompt for OneDrive. It fails closed.
 */
export const resolvePageProducts = (addresses: readonly string[]): PageProductsResult => {
	const perAddress = addresses.map((address) => {
		const providerKey = matchProviderKey(address);

		return providerKey ? resolveProviderKeyToAppId(providerKey) : undefined;
	});
	const matched = perAddress.filter((appId) => appId !== undefined);

	// Every address either names one product or names none, so the shortfall is the unmatched count.
	return { appIds: new Set(matched), unmatchedAddressCount: addresses.length - matched.length };
};
